import {Component, OnDestroy, OnInit} from "@angular/core";
import {Subscription} from "rxjs";
import {
  ParametrageFacturationHierarchy
} from "../../../../core/models/facturation/client/parametrage-facturation-hierarchy";
import {NamedItem} from "../../../../core/models/named-item";
import {FacturationClientService} from "../../../../core/services/entities/facturation-client.service";
import {UtilsService} from "../../../../core/utils/utils.service";
import {
  FilterExportAnalyseFinanciere
} from "../../../../core/models/facturation/client/filter-export-analyse-financiere";
import {saveAs} from "file-saver";

@Component({
  selector: 'yo-analyse-financiere-export',
  templateUrl: './analyse-financiere-export.component.html',
  styleUrls: ['./analyse-financiere-export.component.scss']
})

export class AnalyseFinanciereExportComponent implements OnInit, OnDestroy {

  typeExport = type;
  subHierarchy: Subscription;
  subHierarchiePlat: Subscription;
  subOpenDialog: Subscription;
  selectedPeriode: Date[] = [new Date(), new Date()];
  public cellTypes = AddZoneProperty;

  public hierarchy: ParametrageFacturationHierarchy;
  public hierarchyPlat: ParametrageFacturationHierarchy;

  public offreAlimentaireList: NamedItem[] = [];
  public prestationList: NamedItem[] = [];
  public repasList: NamedItem[] = [];
  public regimeList: NamedItem[] = [];
  public pointFacturationList: NamedItem[] = [];
  public pointLivraisonList: NamedItem[] = [];

  public selectedOffreAlimentaireList: number[] = [];
  public selectedRepasList: number[] = [];
  public selectedRegimeList: number[] = [];
  public selectedPointFacturationList: number[] = [];
  public selectedPointLivraisonList: number[] = [];
  public selectedPrestationList: number[] = [];
  displayDialog: boolean = false;
  selectedTab: type = type.PRESTATION;


  constructor(private facturationClientSvc: FacturationClientService,
              private utilsSvc: UtilsService) {
  }

  ngOnInit(): void {
    this.initHierarchy();
    this.initHierarchiePlat();
    this.subDialog();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subHierarchy);
    this.utilsSvc.unsubscribe(this.subHierarchiePlat);
  }


  private initHierarchy() {
    this.subHierarchy = this.facturationClientSvc.findLigneParametrageHierarchy().subscribe(result => {
      if (result) {
        this.hierarchy = result.one;
        this.pointFacturationList = this.hierarchy.pointsFacturation;
        this.updateValuePrestation([], AddZoneProperty.POINT_FACTURATION);
      }
    });
  }

  private initHierarchiePlat() {
    this.subHierarchiePlat = this.facturationClientSvc.findLigneExportPlatHierarchy().subscribe(result => {
      if (result) {
        this.hierarchyPlat = result.one;
      }
    });
  }


  /**
   * Permet de mettre à jour la valeur et de réinitialiser les propriétés suivantes
   */
  updateValuePrestation = (value: number[], property: AddZoneProperty) => {
    switch (property) {
      case AddZoneProperty.POINT_FACTURATION:
        this.selectedPointFacturationList = value;
        this.pointLivraisonList = this.initProperty(this.selectedPointFacturationList, this.hierarchy.pointsLivraisonByPointFacturationId);
        value = [];
      // pas de break
      case AddZoneProperty.POINT_LIVRAISON:
        this.selectedPointLivraisonList = value;
        this.offreAlimentaireList = this.initProperty(this.selectedPointLivraisonList, this.hierarchy.offresAlimentaireByPointLivraison);
        value = [];
      // pas de break
      case AddZoneProperty.OFFRE_ALIMENTAIRE:
        this.selectedOffreAlimentaireList = value;
        this.prestationList = this.initProperty(this.selectedOffreAlimentaireList, this.hierarchy.prestationsByOffreAlimentaireId);
        value = [];
      // Pas de break
      case AddZoneProperty.PRESTATION:
        this.selectedPrestationList = value;
        this.repasList = this.initProperty(this.selectedPrestationList, this.hierarchy.repasByPrestationId);
        this.regimeList = this.initProperty(this.selectedPrestationList, this.hierarchy.regimesByPrestationId);
        this.selectedRegimeList = [];
        value = [];
      // Pas de break
      case AddZoneProperty.REPAS:
        this.selectedRepasList = value;
        break;
      case AddZoneProperty.REGIME:
        this.selectedRegimeList = value;
        break;
    }
  }

  updateValuePlat = (value: number[], property: AddZoneProperty) => {
    switch (property) {
      case AddZoneProperty.POINT_LIVRAISON:
        this.selectedPointLivraisonList = value;
        this.offreAlimentaireList = this.initProperty(this.selectedPointLivraisonList, this.hierarchyPlat.offresAlimentaireByPointLivraison);
        value = [];
      case AddZoneProperty.OFFRE_ALIMENTAIRE:
        this.selectedOffreAlimentaireList = value;
        this.prestationList = this.initProperty(this.selectedOffreAlimentaireList, this.hierarchyPlat.prestationsByOffreAlimentaireId);
        value = [];
      // Pas de break
      case AddZoneProperty.PRESTATION:
        this.selectedPrestationList = value;
        this.repasList = this.initProperty(this.selectedPrestationList, this.hierarchyPlat.repasByPrestationId);
        this.regimeList = this.initProperty(this.selectedPrestationList, this.hierarchyPlat.regimesByPrestationId);
        this.selectedRegimeList = [];
        value = [];
      // Pas de break
      case AddZoneProperty.REPAS:
        this.selectedRepasList = value;
        break;
      case AddZoneProperty.REGIME:
        this.selectedRegimeList = value;
        break;
    }
  }


  private initProperty(selected: number[], source: Map<number, NamedItem[]>) {
    let properties: NamedItem[] = [];
    if (selected?.length > 0) {
      let propertyLists: NamedItem[][] = [];
      selected.forEach(element => {
          propertyLists.push(source[element]);
      });

      let propertyIds: number[] = [];
      (propertyLists as any).flatMap(i => i).forEach(item => {
        if (!propertyIds.includes(item.id)) {
          properties.push(item);
          propertyIds.push(item.id);
        }
      });
    }

    return properties;
  }

  isParentSelected(selectedList: number[]) {
    return selectedList?.length > 0;
  }

  private subDialog() {
    this.subOpenDialog = this.facturationClientSvc.openExportSettings$.subscribe(() => {
      this.displayDialog = true
    });
  }

  closeDialog() {
    this.displayDialog = false;
  }

  export(typeExport: type) {
    const filter = new FilterExportAnalyseFinanciere();
    filter.dateDebut = this.selectedPeriode[0];
    filter.dateFin = this.selectedPeriode[1];
    filter.idsRegime = this.selectedRegimeList;
    filter.idsPointDeLivraison = this.selectedPointLivraisonList;
    filter.idsPointDeFacturation = this.selectedPointFacturationList;
    filter.idsPrestation = this.selectedPrestationList;
    filter.idsRepas = this.selectedRepasList;
    switch (typeExport) {
      case type.PRESTATION:
        this.facturationClientSvc.exportAnalyseFinancierePrestation(filter).subscribe((response: any) => {
          const byteCharacters = atob(response.excel);
          const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/vnd.ms-excel' });
          const filename = `analyse-financiere-prestation-${new Date().getTime()}.xlsx`;
          saveAs(blob, filename);
          this.facturationClientSvc.announceExportAnalyseFinancierePrestation(response.data);
        });
        break;
      case type.PLAT:
        this.facturationClientSvc.exportAnalyseFinancierePlat(filter).subscribe((response: any) => {
          const byteCharacters = atob(response.excel);
          const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/vnd.ms-excel' });
          const filename = `analyse-financiere-plat-${new Date().getTime()}.xlsx`;
          saveAs(blob, filename);
          this.facturationClientSvc.announceExportAnalyseFinancierePlat(response.data);
        });
        break;
    }
    this.closeDialog();
  }

  onDateFilterValueChange(data: any) {
    this.selectedPeriode = [data[0], data[1]];
  }

  tabChange($event: any) {
    if (this.selectedTab != $event.itemIndex) {
      this.selectedOffreAlimentaireList = [];
      this.selectedPrestationList = [];
      this.selectedRepasList = [];
      this.selectedRegimeList = [];
      this.selectedPointFacturationList = [];
      this.selectedPointLivraisonList = [];
    }

    switch ($event.itemIndex) {
      case 0:
        this.selectedTab = type.PRESTATION;
        this.pointFacturationList = this.hierarchy.pointsFacturation;
        this.updateValuePrestation([], AddZoneProperty.POINT_FACTURATION);
        break;
      case 1:
        this.selectedTab = type.PLAT;
        this.pointLivraisonList = this.hierarchyPlat.pointsLivraison;
        this.updateValuePlat([], AddZoneProperty.POINT_LIVRAISON);
        break;
    }
  }

}

export enum AddZoneProperty {
  OFFRE_ALIMENTAIRE,
  PRESTATION,
  REPAS,
  REGIME,
  POINT_FACTURATION,
  POINT_LIVRAISON
}

export enum type {
  PRESTATION,
  PLAT

}
